<template>
  <section
    class="w-full flex-1 max-w-7xl items-center mx-auto mt-10 pl-5 border-t-2 border-b-2 border-primaire shadow-lg"
  >
    <h1 class="w-full pb-5 pt-5 font-cursive text-3xl font-extrabold tracking-tight md:text-4xl lg:text-5xl">
      <span class="text-secondaire">Nouveaux</span>&nbsp;<span class="text-primaire">arrivants</span>&nbsp;🐱
    </h1>

    <p class="mx-auto pr-5 text-md md:text-lg lg:text-xl text-justify text-gray-500 md:max-w-full font-serif">
      Découvrez nos adorables chats récemment arrivés ! En raison de l'afflux de nouveaux compagnons, il se peut que
      toutes les photos ne soient pas immédiatement disponibles. Nous vous encourageons à explorer nos sections dédiées
      aux chats disponibles à l’adoption pour rencontrer tous nos petits nouveaux. Chaque adoption est une nouvelle
      chance pour eux !
    </p>

    <div class="container mx-auto pr-4 py-8">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        <div
          v-for="card in cards"
          :key="card.id"
          :class="[
            'relative overflow-hidden rounded-2xl shadow-lg group',
            card.featured ? 'md:col-span-2 md:row-span-2' : ''
          ]"
        >
          <router-link :to="card.to" class="block w-full h-full" :title="card.linkTitle" :aria-label="card.linkTitle">
            <img
              :src="getImageSrc(card.file)"
              :alt="card.alt"
              :title="card.linkTitle"
              :class="card.featured ? 'object-cover w-full h-full' : 'w-full h-48 object-cover'"
              loading="lazy"
            />
            <div
              class="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            >
              <div class="absolute bottom-0 left-0 right-0 p-4">
                <h3 :class="card.featured ? 'text-2xl font-bold text-white' : 'text-xl font-bold text-white'">
                  {{ card.caption }}
                </h3>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import rawCards from '@/data/nouveauxArrivants.json';

const IMAGE_BASE = '/src/assets/images/chats_disponibles/';
const FALLBACK_IMAGE = '/img/animaux_de_la_seconde_chance_adoption.jpg';

const imageModules = import.meta.glob('/src/assets/images/chats_disponibles/*.webp', {
  eager: true,
  import: 'default'
});

const normalizeTo = (to) => (to?.startsWith('/') ? to : `/${to ?? ''}`);
const getImageSrc = (fileName) => imageModules[`${IMAGE_BASE}${fileName}`] ?? FALLBACK_IMAGE;

const cards = rawCards.map((card) => ({
  ...card,
  to: normalizeTo(card.to)
}));
</script>


<style scoped>
img {
  aspect-ratio: 4 / 3;
  width: 100%;
  height: auto;
}
</style>